export class TelefoneDevedor {
  contato:String;
  numero:String;
  ramal:String;
  tipo:String;
}
